<div class="modal-header">
    <h4 class="modal-title">{{ data.sendCertificateDevices?.length }} Sertifikaları Yolla</h4>
</div>

<div class="modal-body">
    <form #form="ngForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="form-group">
            <label for="email">Alıcı Mail</label>
            <input type="email" id="email" name="to" class="form-control" [(ngModel)]="data.to" required email
                #toInput="ngModel" placeholder="example@mail.com" />

            <div *ngIf="toInput.invalid && toInput.touched" class="text-danger mt-1">
                <div *ngIf="toInput.errors?.required">E-posta adresi zorunludur.</div>
                <div *ngIf="toInput.errors?.email">Geçerli bir e-posta adresi giriniz.</div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-secondary" (click)="close()">İptal</button>
    <button class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Gönder</button>
</div>